import React from 'react';
import Search from './Search';
import Filter from './Filter';

class SearchBox extends React.Component {
     
    render() {
        let {handleChosen, handleUnread, handleSearch,searched, clearSearch} = this.props
      
        return (
        <div className="search_box col-sm-3 shadow-box">
            <form className="form">
                <Search 
                    handleSearch={handleSearch}
                    searched={searched}
                    clearSearch={clearSearch}
                />
                <Filter 
                    handleChosen={handleChosen}
                    handleUnread={handleUnread}
                />
            </form>
        </div>
        )
    }
}

export default SearchBox;

